/* eslint-disable compat/compat */
class ProductRecommendationsPanels extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.els.trigger?.elements.forEach(el =>
      this.listeners.add(el, 'click', this.onPanelTriggerHandler.bind(this)),
    )
    this.listeners.add(
      this,
      'closeOtherTriggers',
      this.onPanelCloseHandler.bind(this),
    )

    function awaitEvent (key) {
      return new Promise((resolve, reject) => {
        window.addEventListener(key, e => {
          if (e.detail.successful) {
            resolve(e)
          } else {
            reject(e)
          }
        })
      })
    }

    Promise.allSettled([
      awaitEvent('productAdditionalColorsDataIsReady'),
      awaitEvent('productRecommendationsDataIsReady'),
    ]).then(res => {
      res.forEach(data => {
        if (data.status === 'rejected') {
          if (data.reason.type === 'productAdditionalColorsDataIsReady') {
            this.removePanel('additional-colours')
            this.openPanel('recommended')
          }

          if (data.reason.type === 'productRecommendationsDataIsReady') {
            this.removePanel('recommended')
            this.openPanel('additional-colours')
          }
        } else if (
          data.status === 'fulfilled' &&
          data.value.type === 'productRecommendationsDataIsReady'
        ) {
          try {
            window.iWish &&
              setTimeout(() => window.iWish.checkIwishColl(), 1500)
          } catch (e) {}
          const products = data.value.detail.data
          const pdpGender = this.querySelector(
            '[data-panel-type="recommended"] product-recommendation-carousel',
          )?.dataset.pdpGender
          const genderContext = this.resolveGenderContext(pdpGender)
          const hasVisibleRecommendation = products.some(
            product =>
              product.available === true &&
              this.showRecommendationForGender(product, genderContext),
          )
          if (!hasVisibleRecommendation) {
            this.removePanel('recommended')
          }
        } else if (
          data.status === 'fulfilled' &&
          data.value.type === 'productAdditionalColorsDataIsReady'
        ) {
          const products = data.value.detail.data
          const pdpGender = this.querySelector(
            '[data-panel-type="additional-colours"] product-recommendation-carousel',
          )?.dataset.pdpGender
          const genderContext = this.resolveGenderContext(pdpGender)
          const hasVisibleColour = products.some(product =>
            this.showRecommendationForGender(product, genderContext),
          )
          if (!hasVisibleColour) {
            this.removePanel('additional-colours')
            this.openPanel('recommended')
          }
        }
      })
    })
  }

  resolveGenderContext (pdpGender) {
    if (pdpGender === 'male' || pdpGender === 'female') return pdpGender

    const url = new URL(window.location)
    return (
      url.searchParams.get('gender') ||
      sessionStorage.getItem('gender') ||
      'female'
    )
  }

  showRecommendationForGender (product, genderContext) {
    if (genderContext !== 'male' && genderContext !== 'female') return true

    const tags = product.tags || []
    const isMale = tags.includes('gender: men')
    const isFemale = tags.includes('gender: women')
    const isMaleOnly = isMale && !isFemale
    const isFemaleOnly = isFemale && !isMale

    if (genderContext === 'female') return !isMaleOnly
    return !isFemaleOnly
  }

  /** @param {'additional-colours' | 'recommended'} name */
  removePanel (name) {
    const panel = this.els.panel.elements.find(
      panel => panel.dataset.panelType === name,
    )
    const trigger = this.els.trigger.elements.find(
      trigger => trigger.dataset.panelType === name,
    )

    panel?.remove()
    trigger?.parentElement.remove()
  }

  /** @param {'additional-colours' | 'recommended'} name */
  openPanel (name) {
    if (this.els.panel) {
      this.els.panel.elements.forEach(panel => {
        panel.setAttribute('aria-hidden', panel.dataset.panelType !== name)
      })
    }

    if (this.els.trigger) {
      this.els.trigger.elements.forEach(trigger => {
        const isActive = trigger.dataset.panelType === name
        trigger.setAttribute('aria-disabled', isActive)
        trigger.setAttribute('aria-expanded', isActive)
      })
    }
  }

  /** @param {Event} event */
  onPanelTriggerHandler (event) {
    /** @type {HTMLButtonElement} */
    const trigger = event.target
    const triggerKey = trigger.dataset.ProductRecommendationsPanelsTriggerkey

    this.openPanel(trigger.dataset.panelType)

    const initialiseCarousel = new CustomEvent('initialiseCarousel', {
      bubbles: true,
      detail: {
        openKey: triggerKey,
      },
    })

    event.currentTarget.dispatchEvent(initialiseCarousel)
  }

  onPanelCloseHandler () {
    this.els.trigger.elements.forEach(trigger => {
      const triggerKey = Number(
        trigger.dataset.ProductRecommendationsPanelsTriggerkey,
      )
      if (triggerKey !== event.detail.openKey) {
        trigger.setAttribute('aria-expanded', false)
        trigger.setAttribute('aria-disabled', false)
      }
    })
  }
}

if (!customElements.get('product-recommendations-panels')) {
  customElements.define(
    'product-recommendations-panels',
    ProductRecommendationsPanels,
  )
}
